var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("AuthForm"),
      _vm._v(" "),
      _c("Join"),
      _vm._v(" "),
      _c("SignupForm"),
      _vm._v(" "),
      _c("InfoPopup"),
      _vm._v(" "),
      _c("Agreement"),
      _vm._v(" "),
      _c("BecomePro"),
      _vm._v(" "),
      _c("DeleteComment"),
      _vm._v(" "),
      _c("DeleteGroup"),
      _vm._v(" "),
      _c("DeletePhoto"),
      _vm._v(" "),
      _c("DeletePost"),
      _vm._v(" "),
      _c("DeleteReply"),
      _vm._v(" "),
      _c("LeaveGroup"),
      _vm._v(" "),
      _c("PleaseLogIn"),
      _vm._v(" "),
      _c("PostForm"),
      _vm._v(" "),
      _c("SearchCardCollection"),
      _vm._v(" "),
      _c("Thanks"),
      _vm._v(" "),
      _c("CollectionVideoPreview")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }